import React, { Component, Fragment } from "react";
import {
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Button,
} from "react-bootstrap";
import "./login.css";
import { Auth } from "aws-amplify";
import LoaderButton from "../LoaderButton";
import { Link } from "react-router-dom";
import DocumentSync from "../../Component/Images/DocumentSync-Logo.png";
import {
  checkIpAddress,
  saveAuditTrail,
  getUserDetailsByEmail,
  getRequireMfabyClientSql,
} from "../../libs/API";
import GeolocationIp from "../../../node_modules/ip-geolocation-api-javascript-sdk/IPGeolocationAPI";
import EnableTotpPopup from "./enabletotppopup";
import MfaSelectionPopup from "../Login/MfaSelectionPopup";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      mfaToken: "",
      isLoading: false,
      ip: "",
      showMfa: false,
      showNonMfa: true,
      showEnableTotpPopup: false,
      showMfaSelection: false,
      selectedMfaType: null,
      MfaChallenge: "",
      user: null,
    };

    // Create reference for component mounted state to prevent state updates after unmount
    this._isMounted = false;

    // Bind methods to prevent recreation on each render
    this.handleChildUnmount = this.handleChildUnmount.bind(this);
    this.login = this.login.bind(this);
    this.authenticate = this.authenticate.bind(this);
    this.handleResponse = this.handleResponse.bind(this);
    this.mfaConfirm = this.mfaConfirm.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleMfaSelection = this.handleMfaSelection.bind(this);
    this.closeMfaSelection = this.closeMfaSelection.bind(this);
    this.handleHideEnableButton = this.handleHideEnableButton.bind(this);
  }

  async componentDidMount() {
    this._isMounted = true;
    try {
      const ipGeo = new GeolocationIp(
        "fbb2e1a5614b4c9ca16c8e3e46b1e785",
        false
      );
      ipGeo.getGeolocation(this.handleResponse);
    } catch (error) {
      console.error("Error initializing geolocation:", error);
    }
    // // Redirect if already signed in
    // try {
    //   let user = await Auth.currentAuthenticatedUser();
    //   const session = await Auth.currentSession();
    //   const payload = session.getIdToken().decodePayload(); // decoded object
    //   this.setState({ username: payload.email });
    //   await this.authenticate(user);
    // } catch {
    //   // not signed in, continue to login
    // }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  // Safe setState that checks if component is still mounted
  safeSetState(newState) {
    if (this._isMounted) {
      this.setState(newState);
    }
  }

  handleChildUnmount() {
    this.safeSetState({
      showEnableTotpPopup: false,
      showMfaSelection: false,
      showNonMfa: true,
      showMfa: false,
      isLoading: false,
    });
  }

  handleHideEnableButton() {
    this.safeSetState({
      showEnableTotpPopup: false,
      showMfaSelection: false,
      isLoading: false,
    });
  }

  handleMfaSelection(type) {
    this.safeSetState({
      selectedMfaType: type,
      showMfaSelection: false,
      showEnableTotpPopup: true,
    });
  }

  closeMfaSelection() {
    this.safeSetState({
      showMfaSelection: false,
      showNonMfa: true,
      isLoading: false,
    });
  }

  handleInputChange(e) {
    this.setState({ [e.target.id]: e.target.value });
  }

  handleResponse(json) {
    this.safeSetState({ ip: json.ip });
  }

  async login(e) {
    e.preventDefault();
    // const submitter = e.nativeEvent.submitter;
    this.safeSetState({ isLoading: true });

    // If Azure button triggered the submit
    // if (submitter && submitter.name === "azure") {
    //   try {
    //     await Auth.federatedSignIn({ provider: "AzureAD" });
    //     // AuthCallback will handle post-login flow
    //   } catch (err) {
    //     console.error("Federated sign-in error:", err);
    //     this.safeSetState({ isLoading: false });
    //   }
    //   return;
    // }

    // Early validation
    if (!this.state.username || !this.state.password) {
      alert("Please enter both username and password");
      return;
    }

    this.safeSetState({ isLoading: true });

    try {
      const user = await Auth.signIn(this.state.username, this.state.password);

      const hasMfaChallenge =
        user.challengeName === "SMS_MFA" ||
        user.challengeName === "SOFTWARE_TOKEN_MFA";

      if (hasMfaChallenge) {
        // MFA challenge presented; don't call protected API yet
        this.safeSetState({
          user,
          showMfa: true,
          showNonMfa: false,
          showEnableTotpPopup: false,
          isLoading: false,
          MfaChallenge: user.challengeName,
        });
        return;
      }

      // User authenticated successfully without MFA
      // First get user details
      const userDetails = await getUserDetailsByEmail(this.state.username);
      const clientId = userDetails?.[0]?.clientId;

      // Then check MFA requirements
      const requireMfa = await this.fetchMfaRequirement(clientId);

      if (requireMfa) {
        this.safeSetState({
          user,
          showMfaSelection: true,
          showNonMfa: false,
          showMfa: false,
          isLoading: false,
        });
        return;
      }

      // If no MFA required, proceed with authentication
      await this.authenticate(user);
    } catch (err) {
      const message =
        {
          UserNotConfirmedException: "Please confirm your account via email.",
          PasswordResetRequiredException: "Please reset your password.",
          NotAuthorizedException: "Incorrect username/password.",
          UserNotFoundException: "Account not found.",
        }[err.code] || err.message;

      alert(message);
      this.safeSetState({ isLoading: false });
    }
  }

  async fetchMfaRequirement(clientId) {
    if (!clientId) return false;

    try {
      return await getRequireMfabyClientSql(clientId);
    } catch (error) {
      console.error("Failed to fetch MFA requirement:", error);
      return false;
    }
  }

  async authenticate(user) {
    try {
      // Set user permissions
      await this.props.props.setUserPermissions(this.state.ip);
      const auditDetails = {
        emailAddress: this.state.username,
        ipAddress: this.state.ip,
        eventLog: "LogIn",
      };

      // Check IP restrictions if applicable
      if (this.props.props.groups.includes("DocumentSync_RestrictAccessByIP")) {
        const ipParams = {
          userEmailAddress: this.state.username,
          ipAccess: this.state.ip,
        };

        const ipData = await checkIpAddress(ipParams);

        if (ipData.status !== 200) {
          alert("IP is restricted.");
          await Auth.signOut();
          this.safeSetState({ isLoading: false });
          return;
        }
      }

      // Save audit details and navigate
      await saveAuditTrail(auditDetails);

      if (this._isMounted) {
        this.props.history.push("/browse");
      }
    } catch (error) {
      console.error("Authentication error:", error);
      alert("An error occurred during login. Please try again.");
      await Auth.signOut();
      this.safeSetState({ isLoading: false });
    }
  }

  async mfaConfirm(e) {
    e.preventDefault();

    if (!this.state.mfaToken) {
      alert("Please enter the MFA code");
      return;
    }

    this.safeSetState({ isLoading: true });

    try {
      let mfaType;
      if (this.state.selectedMfaType) {
        mfaType =
          this.state.selectedMfaType === "SMS"
            ? "SMS_MFA"
            : "SOFTWARE_TOKEN_MFA";
      } else {
        mfaType =
          this.state.MfaChallenge === "SMS_MFA"
            ? "SMS_MFA"
            : "SOFTWARE_TOKEN_MFA";
      }

      // Confirm sign-in with MFA code
      const loggedUser = await Auth.confirmSignIn(
        this.state.user,
        this.state.mfaToken,
        mfaType
      );

      try {
        await this.authenticate(loggedUser);
      } catch (detailsError) {
        console.error(
          "Error fetching user details after MFA confirmation:",
          detailsError
        );
        alert(
          "Authentication successful but error occurred while loading user details. Please try again."
        );
        await Auth.signOut();
        this.safeSetState({ isLoading: false });
      }
    } catch (err) {
      const errorMessages = {
        CodeMismatchException: "Invalid verification code. Please try again.",
        ExpiredCodeException:
          "Verification code has expired. Please enter a new code.",
        LimitExceededException:
          "Too many failed attempts. Please try again later.",
      };

      alert(errorMessages[err.code] || err.message);
      this.safeSetState({ isLoading: false });
    }
  }

  renderMFaCode() {
    return (
      <form onSubmit={this.mfaConfirm} autoComplete="off">
        <div id="logincontent">
          <div id="logo">
            <Link to="/">
              <img src={DocumentSync} alt="DocumentSync" />
            </Link>
          </div>
          <br />
          <br />
          <HelpBlock>
            Enter an Authentication code to complete sign-in.
          </HelpBlock>
          <FormGroup controlId="mfaToken">
            <ControlLabel>Authentication Code:</ControlLabel>
            <FormControl
              componentClass="input"
              onChange={this.handleInputChange}
              value={this.state.mfaToken}
              type="text"
              autoComplete="off"
              required
            />
          </FormGroup>
          <FormGroup>
            <LoaderButton
              block
              bsClass="btn btn-outline-secondary"
              bsSize="large"
              disabled={this.state.isLoading}
              type="submit"
              isLoading={this.state.isLoading}
              text="Submit"
              loadingText="Logging in..."
            />
          </FormGroup>
        </div>
      </form>
    );
  }

  renderEnableTotpPopup() {
    return (
      <Fragment>
        {this.state.showEnableTotpPopup && (
          <EnableTotpPopup
            props={{
              showEnableTotpPopup: this.state.showEnableTotpPopup,
            }}
            unmountMe={this.handleChildUnmount}
            handleHideEnableButton={this.handleHideEnableButton}
            mfaType={this.state.selectedMfaType}
          />
        )}
      </Fragment>
    );
  }

  renderMfaSelectionPopup() {
    return (
      <Fragment>
        {this.state.showMfaSelection && (
          <MfaSelectionPopup
            isOpen={this.state.showMfaSelection}
            onClose={this.closeMfaSelection}
            onSelectMfaType={this.handleMfaSelection}
          />
        )}
      </Fragment>
    );
  }

  renderLoginWithOutMfa() {
    return (
      <form onSubmit={this.login} autoComplete="off">
        <div id="logincontent">
          <div id="logo">
            <Link to="/">
              <img src={DocumentSync} alt="DocumentSync" />
            </Link>
          </div>
          <br />
          <br />
          <FormGroup controlId="username">
            <ControlLabel>Username:</ControlLabel>
            <FormControl
              componentClass="input"
              onChange={this.handleInputChange}
              value={this.state.username}
              type="text"
              autoComplete="off"
            />
          </FormGroup>
          <FormGroup controlId="password">
            <ControlLabel>Password:</ControlLabel>
            <FormControl
              componentClass="input"
              onChange={this.handleInputChange}
              value={this.state.password}
              type="password"
              autoComplete="off"
            />
          </FormGroup>
          <FormGroup>
            <Link to="/login/reset">Forgot password?</Link>
          </FormGroup>

          <FormGroup>
            <LoaderButton
              block
              bsClass="btn btn-outline-secondary"
              bsSize="large"
              disabled={
                !this.state.username ||
                !this.state.password ||
                this.state.isLoading
              }
              type="submit"
              isLoading={this.state.isLoading}
              text="Login"
              loadingText="Logging in..."
            />
          </FormGroup>
          <FormGroup>
            <Button
              block
              bsClass="btn btn-outline-secondary"
              bsSize="large"
              type="button"
              onClick={() => this.props.history.push("/login/azure")}
              disabled={this.state.isLoading}
              style={{ display: "none" }}
            >
              Login with Azure AD
            </Button>
          </FormGroup>
        </div>
      </form>
    );
  }

  render() {
    const { showNonMfa, showMfa, showEnableTotpPopup } = this.state;
    return (
      <Fragment>
        <div id="loginmain">
          <div id="loginheader"></div>
          {showNonMfa && this.renderLoginWithOutMfa()}
          {showMfa && !showEnableTotpPopup && this.renderMFaCode()}
          {this.renderEnableTotpPopup()}
          {this.renderMfaSelectionPopup()}
          <div id="footer">
            <p>
              &copy; {new Date().getFullYear()} Foveonics Document Solutions
            </p>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Login;
